import React, { useState, useCallback, useMemo, useEffect, useRef } from 'react';
import './MarkerDrawer.css';
import PopupDrawerV2 from './Card/PopupDrawerMain';
import CustomSliderThirdwidth from "./Slider/CustomSlider-thirdwidth";

// --- Utility Icons ---
const PlayIcon = ({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none" className={className}>
        <polygon points="5 3 19 12 5 21 5 3"></polygon>
    </svg>
);

const HeartIcon = ({ className = "" }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
    </svg>
);

const ChevronLeft = ({ className = "", onClick }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} onClick={onClick} style={{ cursor: 'pointer' }}>
        <path d="m15 18-6-6 6-6" />
    </svg>
);

const ChevronRight = ({ className = "", onClick }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} onClick={onClick} style={{ cursor: 'pointer' }}>
        <path d="m9 18 6-6-6-6" />
    </svg>
);

// --- PostModal Style Icons ---
const MoreVerticalIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#888888' }}>
        <circle cx="12" cy="12" r="1" /><circle cx="12" cy="5" r="1" /><circle cx="12" cy="19" r="1" />
    </svg>
);

const HeartIconOutline = ({ active = false, size = 24 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
        fill={active ? 'red' : 'none'}
        stroke={active ? 'red' : 'currentColor'}
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
        style={{ color: active ? '#ef4444' : '#ffffff' }}
    >
        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
    </svg>
);

const CommentIcon = ({ size = 24 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#ffffff' }}>
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
);

const ShareIcon = ({ size = 24 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#ffffff' }}>
        <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
        <polyline points="16 6 12 2 8 6" />
        <line x1="12" y1="2" x2="12" y2="17" />
    </svg>
);

const BookmarkIcon = ({ size = 24 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#ffffff' }}>
        <path d="m19 21-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z" />
    </svg>
);

// --- New Utility Icons for MomentView ---
const ArrowLeft = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 19-7-7 7-7" /><path d="M19 12H5" /></svg>
);
const X = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18" /><path d="m6 6 12 12" /></svg>
);
const EyeOff = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.5 10.5l-6-6" /><path d="M19 19l-4.5-4.5" /><path d="M12 5c3.7 0 7 2.4 10 7-1.3 2.1-3 3.7-4.9 4.9" /><path d="M9.1 14.9a3 3 0 0 1-4.9-3c1.3-2.1 3-3.7 4.9-4.9" /><path d="M16.9 9.1a3 3 0 0 0-4.9-3c-1.3 2.1-3 3.7-4.9 4.9" /></svg>
);
const Eye = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" /></svg>
);
const MapPin = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 21.7C17.3 17 21 13 21 9a9 9 0 0 0-18 0c0 4 3.7 8 9 12.7z" /><circle cx="12" cy="9" r="2.5" /></svg>
);
const Hand = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 12.5a2.3 2.3 0 0 0 2.3-2.3c0-1.4-1.3-2.7-2.3-2.7h-3.9c-.3 0-.5-.2-.5-.5s.2-.5.5-.5H18c1.7 0 3-.9 3.7-2.3.4-.9.2-2.1-.5-2.8l-1.4-1.4c-.7-.7-1.8-.9-2.8-.5C16.9 2 16 3.3 16 5V12h2z" /><path d="M14 12V5c0-1.2-.8-2.5-2-3-1.4-.6-2.9-.1-3.6 1L6 6c-2.3 2.3-2.3 5.3 0 7.6L12 20h8c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2h-8z" /></svg>
);
const MessageCircle = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M7.9 20A10 10 0 0 0 21 12c0-4.4-3.6-8-8-8a9.9 9.9 0 0 0-8 4v8.5l-4 4 4-4z" /></svg>
);

// --- PostUser Component ---
const PostUser = ({ name, id, isVerified = true, isFollowing = false }) => (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '12px',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        flexShrink: 0
    }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ width: '40px', height: '40px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
                <img src={`https://i.pravatar.cc/150?u=post-${id}`} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <span style={{ fontWeight: '700', fontSize: '12px', color: '#ffffff' }}>{name}</span>
                    {isVerified && (
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#3b82f6">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8.59l-9 9z" />
                        </svg>
                    )}
                </div>
                <span style={{ fontSize: '12px', color: '#888888' }}>@{name.toLowerCase().replace(/ /g, '')}</span>
            </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <button style={{
                fontSize: '13px',
                fontWeight: '600',
                padding: '6px 16px',
                borderRadius: '20px',
                border: 'none',
                background: isFollowing ? 'rgba(255,255,255,0.1)' : '#3b82f6',
                color: 'white',
                cursor: 'pointer'
            }}>
                {isFollowing ? 'Following' : 'Follow'}
            </button>
            <MoreVerticalIcon />
        </div>
    </div>
);

// --- Comment Component ---
const Comment = ({ user, time, text, likes, isReply = false }) => (
    <div style={{ display: 'flex', gap: '12px', paddingTop: '12px', marginLeft: isReply ? '24px' : '0' }}>
        <div style={{ width: '32px', height: '32px', borderRadius: '50%', overflow: 'hidden', flexShrink: 0 }}>
            <img src={`https://i.pravatar.cc/150?u=${user}`} alt="Profile" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ margin: 0, fontSize: '14px' }}>
                <span style={{ fontWeight: '600', color: '#ffffff', marginRight: '6px' }}>{user}</span>
                <span style={{ color: '#d0d0d0' }}>{text}</span>
            </p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '4px', fontSize: '12px', color: '#888888' }}>
                <span>{time}</span>
                <span style={{ fontWeight: '600' }}>{likes} likes</span>
                <span style={{ fontWeight: '600', cursor: 'pointer' }}>Reply</span>
            </div>
            {isReply && (
                <div style={{ marginTop: '8px', fontSize: '12px', fontWeight: '600', color: '#3b82f6', cursor: 'pointer' }}>
                    View replies (2)
                </div>
            )}
        </div>
        <button style={{ padding: '4px', background: 'none', border: 'none', cursor: 'pointer', flexShrink: 0, alignSelf: 'flex-start' }}>
            <HeartIconOutline size={16} />
        </button>
    </div>
);

/**
 * Reusable Draggable Sheet Component - Height-based (stays at bottom)
 */
const DraggableSheet = ({ children, initialHeight, minHeight, maxHeight, className, onSnap, snapPoints = [] }) => {
    const [isDragging, setIsDragging] = useState(false);
    const [currentHeight, setCurrentHeight] = useState(initialHeight);
    const [startY, setStartY] = useState(0);
    const [startHeight, setStartHeight] = useState(initialHeight);

    const snapToNearest = useCallback((height) => {
        const points = snapPoints.length > 0 ? snapPoints : [minHeight, maxHeight];
        const nearestSnap = points.reduce((prev, curr) =>
            (Math.abs(curr - height) < Math.abs(prev - height) ? curr : prev)
        );
        setCurrentHeight(nearestSnap);
        if (onSnap) onSnap(nearestSnap);
    }, [minHeight, maxHeight, onSnap, snapPoints]);

    const handleStart = useCallback((clientY, e) => {
        if (e && e.preventDefault) e.preventDefault();
        setIsDragging(false);
        setStartY(clientY);
        setStartHeight(currentHeight);
    }, [currentHeight]);

    const handleMove = useCallback((clientY, e) => {
        if (startY === 0) return;
        if (e && e.preventDefault) e.preventDefault();
        if (Math.abs(clientY - startY) > 5) setIsDragging(true);

        // Dragging up (negative deltaY) = increase height
        // Dragging down (positive deltaY) = decrease height
        const deltaY = startY - clientY; // Inverted: up is positive
        let newHeight = startHeight + deltaY;
        newHeight = Math.min(Math.max(newHeight, minHeight), maxHeight);
        setCurrentHeight(newHeight);
    }, [startY, startHeight, minHeight, maxHeight]);

    const handleEnd = useCallback(() => {
        if (startY === 0) return;
        if (isDragging || Math.abs(currentHeight - startHeight) > 20) {
            snapToNearest(currentHeight);
        } else {
            const points = snapPoints.length > 0 ? snapPoints : [minHeight, maxHeight];
            const nearestIndex = points.findIndex(p => p === points.reduce((prev, curr) =>
                (Math.abs(curr - currentHeight) < Math.abs(prev - currentHeight) ? curr : prev)
            ));
            let newIndex = nearestIndex === 0
                ? (points.length > 1 ? 1 : 0)
                : 0;
            newIndex = Math.max(0, Math.min(newIndex, points.length - 1));
            setCurrentHeight(points[newIndex]);
            if (onSnap) onSnap(points[newIndex]);
        }
        setStartY(0);
        setIsDragging(false);
    }, [currentHeight, startY, isDragging, startHeight, snapToNearest, snapPoints, minHeight, maxHeight, onSnap]);

    const sheetStyle = useMemo(() => ({
        height: `${currentHeight}px`,
        transition: isDragging ? 'none' : 'height 0.25s cubic-bezier(0.4, 0.0, 0.2, 1)'
    }), [currentHeight, isDragging]);

    return (
        <div
            className={`marker-draggable-sheet ${className} ${isDragging ? 'dragging' : ''}`}
            style={sheetStyle}
            onMouseDown={(e) => { if (e.target === e.currentTarget) handleStart(e.clientY, e); }}
            onTouchStart={(e) => { if (e.target === e.currentTarget) handleStart(e.touches[0].clientY, e); }}
            onMouseMove={(e) => { if (startY !== 0) handleMove(e.clientY, e); }}
            onMouseUp={handleEnd}
            onMouseLeave={handleEnd}
            onTouchMove={(e) => handleMove(e.touches[0].clientY, e)}
            onTouchEnd={handleEnd}
        >
            <div
                className="marker-handle-bar"
                style={{ zIndex: 10, cursor: 'ns-resize' }}
                onMouseDown={(e) => handleStart(e.clientY, e)}
                onTouchStart={(e) => handleStart(e.touches[0].clientY, e)}
            />
            {children}
        </div>
    );
};

/**
 * SecondDrawer - Displays current marker thumbnail or full MomentView
 */
const SecondDrawer = ({ currentMarker, drawerHeight, mapStyle = 'dark', isExpanded, onExpand, onClose }) => {
    // Basic Drag Logic
    const [dragStartY, setDragStartY] = useState(null);

    const handleDragStart = (e) => {
        const clientY = e.touches ? e.touches[0].clientY : e.clientY;
        setDragStartY(clientY);
    };

    const handleDragEnd = (e) => {
        if (dragStartY === null) return;
        const clientY = e.changedTouches ? e.changedTouches[0].clientY : e.clientY;
        const deltaY = clientY - dragStartY; // Positive = Down, Negative = Up

        if (deltaY < -50) { // Dragged UP
            onExpand();
        }
        setDragStartY(null);
    };

    if (!currentMarker) return null;

    const mediaUrl = currentMarker.media && currentMarker.media.length > 0
        ? (currentMarker.media[0].type === 'video' && currentMarker.media[0].thumbnailUrl
            ? `https://${currentMarker.media[0].thumbnailUrl}`
            : `https://${currentMarker.media[0].url}`)
        : 'https://images.unsplash.com/photo-1545656513-a4478170ba36?q=80&w=400';

    if (isExpanded) {
        return (
            <PopupDrawerV2
                property={currentMarker}
                onClose={onClose}
            />
        );
    }

    // --- Minimized/Thumbnail State ---
    return (
        <div
            className={`second-drawer ${mapStyle}`}
            style={{
                // bottom: `${drawerHeight}px`,
                bottom: `calc(${drawerHeight}px - 32dvh)`,
                width: '100vw',
                left: 0,
                right: 0,
                margin: 0,
                borderRadius: '16px 16px 0 0',
                cursor: 'pointer',
                touchAction: 'none',
                height: '35dvh',
                // backgroundColor: 'transparent',
                backgroundColor: "rgba(250, 250, 250, 0.3)"

            }}
            onClick={onExpand}
            onMouseDown={handleDragStart}
            onMouseUp={handleDragEnd}
            onTouchStart={handleDragStart}
            onTouchEnd={handleDragEnd}
        >
            <div className="marker-handle-bar" style={{ pointerEvents: 'none' }} />
            {/* <div className="second-drawer-content" style={{
                backgroundImage: `url(${mediaUrl})`,
                width: '100%',
                borderRadius: '16px 16px 0 0'
            }}>
                <div className="second-drawer-overlay">
                    <h3>{currentMarker.title || 'Untitled'}</h3>
                    <p>{currentMarker.address || 'No location'}</p>
                </div>
                <div className="second-drawer-controls">
                    <HeartIcon className="control-icon" />
                    <PlayIcon className="control-icon-play" />
                </div>
            </div> */}
        </div>
    );
};

const MarkerDrawer = ({ markers = [], selectedMarker, onMarkerClick, mapStyle = 'dark' }) => {
    const height = window.innerHeight;
    const rowRef = useRef(null);

    const COLLAPSED_HEIGHT = 150;
    const HALF_HEIGHT = height * 0.5;
    const FULL_HEIGHT = height;

    const SNAP_POINTS = [COLLAPSED_HEIGHT, HALF_HEIGHT, FULL_HEIGHT];

    const [isExpanded, setIsExpanded] = useState(false);
    const [activeMarkerIndex, setActiveMarkerIndex] = useState(0);
    const [mediaIndex, setMediaIndex] = useState(0);
    const [mediaWidth, setMediaWidth] = useState(60); // percentage width for media section
    // --- State for SecondDrawer (MomentView) expansion ---
    const [secondDrawerExpanded, setSecondDrawerExpanded] = useState(false);
    const handleSecondDrawerExpand = () => {
        setSecondDrawerExpanded(true);
        setIsExpanded(false); // collapse main drawer when MomentView opens
    };
    const handleSecondDrawerClose = () => {
        setSecondDrawerExpanded(false);
        setIsExpanded(true); // Re-open the main drawer
        setCurrentDrawerHeight(HALF_HEIGHT); // Restore to a visible height
    };
    const [isResizing, setIsResizing] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [currentDrawerHeight, setCurrentDrawerHeight] = useState(COLLAPSED_HEIGHT);

    useEffect(() => {
        if (selectedMarker && markers.length > 0) {
            const index = markers.findIndex(m => m._id === selectedMarker._id);
            if (index !== -1) {
                setActiveMarkerIndex(index);
                setMediaIndex(0); // Reset media index when marker changes
            }
        }
    }, [selectedMarker, markers]);

    const handleSnap = useCallback(
        newHeight => {
            setIsExpanded(newHeight > COLLAPSED_HEIGHT + 50);
            setCurrentDrawerHeight(newHeight);
        },
        [COLLAPSED_HEIGHT]
    );

    const currentMarker = markers[activeMarkerIndex] || null;

    const handlePrevMedia = (e) => {
        e.stopPropagation();
        if (!currentMarker?.media) return;
        setMediaIndex((prev) => (prev === 0 ? currentMarker.media.length - 1 : prev - 1));
    };

    const handleNextMedia = (e) => {
        e.stopPropagation();
        if (!currentMarker?.media) return;
        setMediaIndex((prev) => (prev === currentMarker.media.length - 1 ? 0 : prev + 1));
    };

    // Resize handlers for media/comment divider
    const handleResizeMouseDown = useCallback((e) => {
        if (e.button !== 0) return;
        setIsResizing(true);
        e.preventDefault();
        document.body.style.userSelect = 'none';
        document.body.style.cursor = 'ew-resize';
    }, []);

    const handleResizeTouchStart = useCallback((e) => {
        setIsResizing(true);
        e.preventDefault();
    }, []);

    const handleResizeMouseMove = useCallback((e) => {
        if (!isResizing || !rowRef.current) return;
        const container = rowRef.current;
        const containerRect = container.getBoundingClientRect();
        const clientX = e.touches ? e.touches[0].clientX : e.clientX;
        let newWidth = ((clientX - containerRect.left) / containerRect.width) * 100;
        newWidth = Math.max(15, Math.min(85, newWidth)); // Clamp between 15% and 85%
        setMediaWidth(newWidth);
    }, [isResizing]);

    const handleResizeMouseUp = useCallback(() => {
        if (isResizing) {
            setIsResizing(false);
            document.body.style.userSelect = '';
            document.body.style.cursor = '';
        }
    }, [isResizing]);

    // Add/remove global mouse/touch listeners for resizing
    useEffect(() => {
        if (isResizing) {
            document.addEventListener('mousemove', handleResizeMouseMove);
            document.addEventListener('mouseup', handleResizeMouseUp);
            document.addEventListener('touchmove', handleResizeMouseMove, { passive: false });
            document.addEventListener('touchend', handleResizeMouseUp);
        }
        return () => {
            document.removeEventListener('mousemove', handleResizeMouseMove);
            document.removeEventListener('mouseup', handleResizeMouseUp);
            document.removeEventListener('touchmove', handleResizeMouseMove);
            document.removeEventListener('touchend', handleResizeMouseUp);
        };
    }, [isResizing, handleResizeMouseMove, handleResizeMouseUp]);

    const collapsedContent = useMemo(() => {
        if (!currentMarker) return null;
        return (
            <div className="marker-peek-view">
                <div style={{ padding: '10px 16px' }}>
                    <h3 style={{
                        margin: '0 0 5px 0', fontSize: '16px', fontWeight: '600', WebkitTextStroke: '0.4px',

                        color: '#111827',
                        fontWeight: '600',
                        lineHeight: '1.25',
                        // marginBottom: '8px',
                        marginBottom: '4px',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        marginTop: '8px',
                        WebkitTextStroke: '0.4px',
                        fontSize: '1rem',
                    }}>
                        {currentMarker.title || 'Untitled'}
                    </h3>
                    <p style={{
                        margin: 0, fontSize: '13px', opacity: 0.8, WebkitTextStroke: '0.3px', color: 'rgb(150, 150, 150)',
                        fontSize: '0.8rem',
                        color: 'rgb(150, 150, 150)',

                        fontWeight: '500',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        WebkitTextStroke: '0.3px'

                    }}>
                        {currentMarker.address || 'No location'}
                    </p>
                    {/* <PostUser
                        name={currentMarker.author || "Anonymous User"}
                        id={currentMarker._id}
                        isFollowing={false}
                    /> */}
                </div>
            </div>
        );
    }, [currentMarker]);

    const expandedContent = useMemo(() => {
        if (!currentMarker) return null;

        const currentMedia = currentMarker.media?.[mediaIndex];
        const hasMultipleMedia = currentMarker.media?.length > 1;

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    height: "100%",
                    overflow: "hidden"
                }}
            >
                {/* ROW 1 — FIXED HEIGHT + INTERNAL SCROLL */}
                <div
                    ref={rowRef}
                    style={{
                        height: "40vh",
                        minHeight: "40vh",
                        maxHeight: "40vh",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "row",
                        margin: "2px 8px 8px 8px",
                        borderRadius: "16px",
                        border: "1px solid rgba(255,255,255,0.1)",
                        background: "rgba( 0, 0, 0, 1)"
                    }}
                >

                    {/* MEDIA LEFT (dynamic width) */}
                    <div
                        style={{
                            width: `${mediaWidth}%`,
                            // padding: "2px",
                            padding: "4px 2px 4px 4px",

                            boxSizing: "border-box",
                            background: "#000",
                            borderRadius: "16px 0 0 16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                            transition: isResizing ? "none" : "width 0.15s ease-out"
                        }}
                    >
                        {/* Overlay: Avatar, Username, Follow Button, Action Icons */}
                        <div style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            pointerEvents: "none",
                            zIndex: 2,
                            padding: "12px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                        }}>
                            {/* Top Left: Avatar & Follow */}
                            <div style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: "8px",
                                pointerEvents: "auto",
                                alignSelf: "flex-start"
                            }}>
                                <img
                                    src={`https://i.pravatar.cc/150?u=post-${currentMarker._id}`}
                                    alt="Profile"
                                    style={{ width: "28px", height: "28px", borderRadius: "50%", objectFit: "cover", border: "1px solid rgba(255,255,255,0.8)", top: "2px" }}
                                />


                                {/* <span style={{ fontSize: "11px", fontWeight: "700", color: "white", textShadow: "0 1px 2px rgba(0,0,0,0.8)", }}>
                                    {currentMarker.author || "Anonymous"}
                                </span>
                                <button
                                    style={{
                                        fontSize: "9px",
                                        fontWeight: "600",
                                        padding: "3px 8px",
                                        borderRadius: "10px",
                                        border: "none",
                                        background: "#3b82f6",
                                        color: "white",
                                        cursor: "pointer",
                                        // marginTop: "2px"
                                    }}
                                >
                                    Follow
                                </button> */}
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "2px" }}>
                                    <span style={{ fontSize: "11px", fontWeight: "700", color: "white", textShadow: "0 1px 2px rgba(0,0,0,0.8)", }}>
                                        {currentMarker.author || "Anonymous"}
                                    </span>
                                    <button
                                        style={{
                                            fontSize: "9px",
                                            fontWeight: "600",
                                            padding: "0px 0px",
                                            borderRadius: "10px",
                                            border: "none",
                                            background: "#3b82f6",
                                            color: "white",
                                            cursor: "pointer",
                                            // marginTop: "2px"
                                        }}
                                    >
                                        Follow
                                    </button>
                                </div>
                            </div>

                            {/* Bottom Row */}
                            <div style={{
                                display: "flex",
                                alignItems: "flex-end",
                                justifyContent: "space-between",
                                width: "100%"
                            }}>
                                {/* Bottom Left: Description */}
                                <div style={{
                                    pointerEvents: "auto",
                                    color: "white",
                                    maxWidth: "65%",
                                    fontSize: "12px",
                                    lineHeight: "1.3",
                                    textShadow: "0 1px 2px rgba(0,0,0,0.8)",
                                    marginBottom: "4px"
                                }}>
                                    <span style={{ fontWeight: "700", marginRight: "4px" }}>{currentMarker.author}</span>
                                    <span style={{ opacity: 0.95 }}>{currentMarker.description || currentMarker.title}</span>
                                </div>

                                {/* Bottom Right: Icons */}
                                <div style={{
                                    display: "flex",
                                    gap: "10px",
                                    pointerEvents: "auto",
                                    alignItems: "center",
                                    marginBottom: "4px"
                                }}>
                                    <HeartIconOutline size={22} active={false} />
                                    <CommentIcon size={22} />
                                    <ShareIcon size={22} />
                                </div>
                            </div>
                        </div>
                        <div style={{ position: 'relative', width: '100%', height: '100%', overflow: 'hidden', borderRadius: '12px' }}>
                            {currentMedia?.type === 'video' ? (
                                <video
                                    src={`https://${currentMedia.url}`}
                                    poster={currentMedia.thumbnailUrl ? `https://${currentMedia.thumbnailUrl}` : undefined}
                                    controls
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "12px"
                                    }}
                                />
                            ) : (
                                <img
                                    src={currentMedia ? `https://${currentMedia.url}` : "https://images.unsplash.com/photo-1545656513-a4478170ba36?q=80&w=600"}
                                    alt={currentMarker.title}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        borderRadius: "12px"
                                    }}
                                />
                            )}

                            {hasMultipleMedia && (
                                <>
                                    <div
                                        onClick={handlePrevMedia}
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "8px",
                                            transform: "translateY(-50%)",
                                            padding: "6px 10px",
                                            background: "rgba(0,0,0,0.6)",
                                            borderRadius: "50%",
                                            cursor: "pointer",
                                            color: "white",
                                            fontSize: "16px",
                                            fontWeight: "bold"
                                        }}
                                    >‹</div>

                                    <div
                                        onClick={handleNextMedia}
                                        style={{
                                            position: "absolute",
                                            top: "50%",
                                            right: "8px",
                                            transform: "translateY(-50%)",
                                            padding: "6px 10px",
                                            background: "rgba(0,0,0,0.6)",
                                            borderRadius: "50%",
                                            cursor: "pointer",
                                            color: "white",
                                            fontSize: "16px",
                                            fontWeight: "bold"
                                        }}
                                    >›</div>

                                    <div
                                        style={{
                                            position: "absolute",
                                            bottom: "8px",
                                            left: "50%",
                                            transform: "translateX(-50%)",
                                            padding: "4px 10px",
                                            background: "rgba(0,0,0,0.7)",
                                            borderRadius: "12px",
                                            fontSize: "11px",
                                            color: "white"
                                        }}
                                    >
                                        {mediaIndex + 1} / {currentMarker.media.length}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Resizer Handle */}
                    <div
                        onMouseDown={handleResizeMouseDown}
                        onTouchStart={handleResizeTouchStart}
                        style={{
                            width: "16px",
                            cursor: "ew-resize",
                            flexShrink: 0,
                            // background: isResizing
                            //     ? "rgba(59, 130, 246, 0.5)"
                            //     : mapStyle === 'light'
                            //         ? "rgba(250,250,250,0.9)"
                            //         : "rgba(255,255,255,0.1)",
                            // background: isResizing
                            //     ? "rgba( 250, 250, 250, .1)"
                            //     : mapStyle === 'light'
                            //         ? "rgba(0, 0, 0, .95)"
                            //         : "rgba(3, 2, 2, 0.1)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "background 0.2s ease",
                            borderRadius: "2px",
                            borderColor: "transparent"
                        }}
                    >

                        <div style={{
                            height: "99%",
                            width: "100%",
                            // backgroundColor: "white",
                            background: isResizing
                                ? "rgba( 250, 250, 250, .1)"
                                : mapStyle === 'light'
                                    ? "rgba(0, 0, 0, .95)"
                                    : "rgba(3, 2, 2, 0.1)",
                            borderRadius: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }} >
                            <div style={{
                                width: "3px",
                                height: "40px",
                                background: isResizing
                                    ? "#3b82f6"
                                    : mapStyle === 'light'
                                        ? "rgba(180,180,180,0.8)"
                                        : "rgba(255,255,255,0.3)",
                                borderRadius: "2px"
                            }} />
                        </div>

                    </div>

                    {/* COMMENT SECTION RIGHT (dynamic width) - PostModal Style */}
                    <div
                        style={{
                            width: `${100 - mediaWidth}%`,
                            display: "flex",
                            flexDirection: "column",
                            boxSizing: "border-box",
                            background: "#000", // Match left side background
                            // padding: "2px", // Match left side padding
                            padding: "4px 4px 4px 2px",

                            borderRadius: "0 16px 16px 0",
                            overflow: "hidden",
                            transition: isResizing ? "none" : "width 0.15s ease-out",
                            overflowX: "hidden",
                            // whiteSpace: "normal",
                            // wordWrap: "break-word"
                        }}
                    >
                        {/* Inner Card Container */}
                        <div style={{
                            width: "100%",
                            height: "100%",
                            background: "rgba(30,30,30,0.8)", // Original background moved here
                            borderRadius: "12px", // Rounded corners for the inner card
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden"
                        }}>

                            {/* Comments (Right Side Only) */}
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                flex: 1,
                                minHeight: '100px',
                                overflowY: 'auto',
                                padding: '12px',
                                fontSize: '14px',
                                color: '#d0d0d0',
                                overflowX: "hidden",
                                // wordWrap: "break-word"


                            }}>
                                {/* Caption */}
                                <p style={{ margin: "0 0 12px 0", lineHeight: "1.5", color: "#e0e0e0" }}>
                                    <span style={{ fontWeight: "700", marginRight: "6px", color: "#ffffff" }}>
                                        {currentMarker.author || "Anonymous User"}
                                    </span>
                                    {currentMarker.description || currentMarker.title}
                                    <a href="#" style={{ color: "#3b82f6", marginLeft: "4px", textDecoration: "none" }}>#Location</a>
                                    <a href="#" style={{ color: "#3b82f6", marginLeft: "4px", textDecoration: "none" }}>#Travel</a>
                                </p>

                                {/* Comments using Comment Component */}
                                {currentMarker.comments?.length ? (
                                    currentMarker.comments.map((c, i) => (
                                        <Comment
                                            key={i}
                                            user={c.author}
                                            time="1w"
                                            text={c.text}
                                            likes="12"
                                            isReply={i === 0}
                                        />
                                    ))
                                ) : (
                                    <>
                                        <Comment user="travel_lover" time="1w" text="Amazing place! 😍🏔️" likes="12" isReply={true} />
                                        <Comment user="photographer_dan" time="3d" text="Great shot! The lighting is perfect 📸" likes="5" />
                                        <Comment user="nature_enthusiast" time="6d" text="Breathtaking scenery! 🌿" likes="10" />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* ROW 2 — NATURAL HEIGHT & SCROLLS WITH DRAWER */}
                <div
                    style={{
                        width: "100%",
                        padding: "10px 0px 0px 0px",
                        borderTop: "1px solid rgba(255,255,255,0.1)"
                    }}
                >
                    <h4 style={{ margin: "10px 0 10px", paddingLeft: "10px" }}>
                        Nearby Locations ({markers.length})
                    </h4>


                    <div style={{ margin: "0 2px" }}>

                        <CustomSliderThirdwidth
                            onSlideClick={(obj) => {
                                const idx = markers.findIndex((m) => m._id === obj._id);
                                if (idx !== -1) {
                                    setActiveMarkerIndex(idx);
                                    setMediaIndex(0);
                                    if (onMarkerClick) onMarkerClick(obj._id);
                                }
                            }}
                        />
                    </div>


                </div>
            </div>
        );
    }, [currentMarker, markers, activeMarkerIndex, onMarkerClick, mediaIndex, mediaWidth, isResizing, handleResizeMouseDown, handleResizeTouchStart, handlePrevMedia, handleNextMedia, mapStyle]);

    if (!markers?.length) return null;

    return (

        <>
            <SecondDrawer
                currentMarker={currentMarker}
                drawerHeight={currentDrawerHeight}
                mapStyle={mapStyle}
                isExpanded={secondDrawerExpanded}
                onExpand={handleSecondDrawerExpand}
                onClose={handleSecondDrawerClose}
            />


            <DraggableSheet
                className={`marker-drawer-sheet ${mapStyle}`}
                initialHeight={COLLAPSED_HEIGHT}
                minHeight={COLLAPSED_HEIGHT}
                maxHeight={FULL_HEIGHT}
                snapPoints={SNAP_POINTS}
                onSnap={handleSnap}
            >
                <div className="marker-sheet-content">
                    {isExpanded ? expandedContent : collapsedContent}
                </div>
            </DraggableSheet>

        </>


    );
};

export default MarkerDrawer;
